<template>
  <div class="wrapper">
    <div class="header">
      <span></span>
    </div>
    <v-chart
      id="main"
      ref="chart"
      :option="option"
      autoresize
      style="min-height: 550px; min-width: 550px;"
      @click="onClickPieChart"
    />
  </div>
</template>

<script>
import {use} from "echarts/core";
import {CanvasRenderer} from "echarts/renderers";
import {PieChart} from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  TimelineComponent
]);
import VChart from "vue-echarts";
import {mapGetters} from "vuex";
import {TimelineComponent} from 'echarts/components';

export default {
  name: "PresentWeekStatus",
  components: {
    VChart,
  },
  data() {
    return {
      keys: ["excellent", "good", "terrible"],
      projectTypes: ["SPOT", "LABO", "Maintain", "Other"],
      option: {
        legend: {
          orient: 'horizontal',
          left: 'center',
          data: ['Apple', 'Grapes', 'Pineapples', 'Oranges', 'Bananas'],
          textStyle: {
            fontFamily: 'Helvetica'
          }
        },
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontFamily: 'Helvetica',
            fontSize: 16
          },
          borderColor: 'none',
          padding: 0,
          borderWidth: 0,
          formatter: (params) => {
            const projectList = this.projectStatusStatisticsTooltip;
            const projectsByType = projectList[this.keys[params.data.id - 1]].reduce(function (r, a) {
              r[a.project_type] = r[a.project_type] || [];
              r[a.project_type].push(a);
              return r;
            }, []).filter(element => element !== null);
            let string = "<div class='p-0' style='border-radius: 10px;min-width: 350px;'>";
            string += "<div style='background-color: #E0E0E0;width: 100%;text-align: center;padding: 10px;'><span style='font-family: Helvetica;color:#303C54;font-weight:700;font-size:14px;'>Danh sách dự án</span></div>";
            string += "<div style='width: 100%;padding: 15px;'><div style='width: 100%;border: 1px solid #ECECEC;border-radius: 1em'>";
            projectsByType.forEach((element, index) => {
              string += `<div class="d-flex" style="width: 100%;align-items: center;${projectsByType.length === index + 1 ? '' : 'border-bottom: 1px solid #ECECEC;'}">
                            <div style="color:#303C54;font-weight:400;font-size:14px;font-family: 'Helvetica';width:25%;border-right: 1px solid #ECECEC;padding: 6px 10px;">${this.projectTypes[parseInt(element[0].project_type) - 1]}</div>
                            <div style="color:#17A896;font-weight:700;font-size:14px;font-family: 'Helvetica';width:75%;padding: 6px 10px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">${element.map((record) => record.name).toString()}</div>
                          </div>`;
            })
            string += "</div></div></div>"
            return string;
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['25%', '75%'],
            // top: 10,
            label: {
              show: true,
              formatter: '{b|{b}}\n{d|{d}%}',
              rich: {
                b: {
                  color: '#303C54',
                  fontFamily: 'Helvetica',
                  fontSize: 20,
                  fontWeight: 700,
                  padding: [0, 0, 0, 0]
                },
                d: {
                  color: '#929292',
                  fontFamily: 'Helvetica',
                  fontSize: 20,
                  fontWeight: 400,
                  padding: [5, 0, 0, 0]
                }
              },
              textStyle: {
                fontSize: 20,
                fontFamily: 'Helvetica'
              }
            },
            data: [],
            labelLine: {
              length: 50,
              length2: 50,
              lineStyle: {
                color: '#CFCFCF',
                width: 1
              },
              showAbove: true
            },
            markLine: {
              label: {
                position: 'start'
              }
            },
            emphasis: {
              scaleSize: 25
            }
          },
          {
            type: 'pie',
            radius: ['25%', '75%'],
            label: {
              show: false,
              formatter: '{b}\n{c}',
              rich: {
                b: {
                  color: '#303C54',
                  fontWeight: 700,
                },
                c: {
                  color: '#929292',
                  fontWeight: 400,
                }
              },
            },
            avoidLabelOverlap: true,
            data: [],
            labelLine: {
              length: 0,
              length2: 200,
              lineStyle: {
                color: '#CFCFCF',
                width: 1
              },
              showAbove: true
            },
            markLine: {
              label: {
                position: 'start'
              }
            },
            emphasis: {
              scaleSize: 25
            }
          },
          {
            type: 'pie',
            radius: ['25%', '75%'],
            label: {
              show: true,
              position: 'inside',
              formatter: '{c}',
              color: '#FFFFFF',
              fontSize: 24,
              fontWeight: 700,
              fontFamily: 'Helvetica'
            },
            avoidLabelOverlap: true,
            data: [],
            labelLine: {
              length: 0,
              length2: 200,
              lineStyle: {
                color: '#CFCFCF',
                width: 1
              },
              showAbove: true
            },
            markLine: {
              label: {
                position: 'start'
              }
            },
            emphasis: {
              scaleSize: 25
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      projectStatusStatistics: "project/projectStatusStatistics",
      projectStatusStatisticsTooltip: "project/projectStatusStatisticsTooltip"
    })
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      await this.$store.dispatch("project/getProjectStatusStatistics");
      this.option.series.forEach(element => {
        element.data = this.projectStatusStatistics.project_status.filter(element => element.value !== 0);
      })
    },
    onClickPieChart(e) {

    }
  }
}
</script>

<style scoped>

</style>
